/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css, html } from 'lit';
import { property } from 'lit/decorators.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
import C4DContentGroup from '../content-group/content-group';
import '../horizontal-rule/horizontal-rule';
import styles from './content-block-horizontal.scss';

const { stablePrefix: c4dPrefix } = settings;

/**
 * Horizontal version of content group.
 *
 * @element c4d-content-block-horizontal
 * @csspart hr - The horizontal rule element that appears when the border property is true. Usage: `c4d-content-block-horizontal::part(hr)`
 */
@customElement(`${c4dPrefix}-content-block-horizontal`)
class C4DContentBlockHorizontal extends C4DContentGroup {
  @property({ type: Boolean, reflect: true, attribute: 'border' })
  border = false;

  render() {
    return html`
      ${super.render()}
      ${this.border ? html` <c4d-hr part="hr"></c4d-hr> ` : ''}
    `;
  }

  static get stableSelector() {
    return `${c4dPrefix}--content-block-horizontal`;
  }

  // `styles` here is a `CSSResult` generated by custom WebPack loader
  static get styles() {
    return css`
      ${super.styles}${styles}
    `;
  }
}

console.warn(
  'The content-block-horizontal component has been deprecated in favor of the content-section/block and content item horizontal component. ' +
    'See content-section/block and content item horizontal documentation for more information.'
);

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DContentBlockHorizontal;
